/* ============================================================
   EQUIPIFY Slate & Teal — global behaviors (dependency-free).
   - Hover-open for the header dropdown/mega menus (Dawn's
     <details>/<summary> menus already support click + keyboard;
     this adds hover on fine pointers, matching the prototype).
   ============================================================ */
(function () {
  'use strict';

  function initNavHover() {
    var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!hoverable) return;

    var items = document.querySelectorAll('.header__inline-menu header-menu > details');
    Array.prototype.forEach.call(items, function (details) {
      var parent = details.closest('li') || details;
      var closeTimer = null;

      function setOpen(on) {
        if (on) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      parent.addEventListener('mouseenter', function () {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        // close siblings
        var open = document.querySelectorAll('.header__inline-menu details[open]');
        Array.prototype.forEach.call(open, function (other) {
          if (other !== details) other.removeAttribute('open');
        });
        setOpen(true);
      });

      parent.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          setOpen(false);
        }, 120);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = document.querySelectorAll('.header__inline-menu details[open]');
        Array.prototype.forEach.call(open, function (d) {
          d.removeAttribute('open');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavHover);
  } else {
    initNavHover();
  }
})();
